module.exports = __webpack_public_path__ + "img/Diagram@3x.198382b4.png";